// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorDivStyle{
    position:fixed;
    background-color: #FFF3CD; 
    color:#856404; 
    height:auto; 
    width:200px;
    font-size:0.7em;
    z-index: 1000;
    padding:5px 5px 5px 5px;
    border-radius: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
